import {SAVE_NETWORK_SETTINGS, GET_NICS, GET_ABOUT, RESET_PWD, GET_SSH_STATUS, GET_SERVER_ACTION} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function sysConfigReducer(state = initialState.sysConfig, action) {
  let newState;

  switch (action.type) {

    case SAVE_NETWORK_SETTINGS:
      if(action.error){
        newState = objectAssign({}, state, {error: action.error});
      }
      else{
        newState = objectAssign({}, state, {message: action.message})
      }
      return newState;


    case GET_NICS:
    if(action.error){
      newState = objectAssign({}, state, {error: action.error});
    }
    else{
      newState = objectAssign({}, state, {nics: action.nics})
    }
    return newState;

    case GET_ABOUT:
    if(action.error){
      newState = objectAssign({}, state, {error: action.error});
    }
    else{
      newState = objectAssign({}, state, {about: action.about})
    }
    return newState;

    case RESET_PWD:
    if(action.error){
      newState = objectAssign({}, state, {error: action.error});
    }
    else{
      newState = objectAssign({}, state, {password: '', newPassword: ''})
    }
    return newState;

    case GET_SSH_STATUS:
    if(action.error){
      newState = objectAssign({}, state, {error: action.error});
    }
    else{
      newState = objectAssign({}, state, {enableSSH: action.enableSSH})
    }
    return newState;

    case GET_SERVER_ACTION:
      newState = objectAssign({}, state, {...action.payload})
    return newState;

    default:
      return state;
  }
}
